var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignMetrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.45251,
    y: 1.98596,
    width: 8.74083,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(45 8.45251 1.98596)",
    fill: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9853,
    y: 1.06067,
    width: 11.6958,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(135 21.9853 1.06067)",
    fill: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.90097,
    y: 3.11475,
    width: 11.0879,
    height: 0.75,
    rx: 0.375,
    transform: "rotate(135 8.90097 3.11475)",
    stroke: "#3E3D3D",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 17.0002,
    width: 5,
    height: 6.5,
    rx: 0.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11.0002,
    width: 5,
    height: 12.5,
    rx: 0.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 6.50024,
    width: 5,
    height: 17,
    rx: 0.5,
    stroke: "#3E3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignMetrics);
export default __webpack_public_path__ + "static/media/campaignMetrics.a79e6aded3b681278c300aefecf71088.svg";
export { ForwardRef as ReactComponent };